import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { LinearProgress } from "@material-ui/core";

import { configChart } from "./configChart";

ChartJS.register(ArcElement, Tooltip, Legend);

function GraphicDoughnut({ title, data, loading }) {
  const config = configChart(title);

  const labels = Object.keys(data).sort();

  const result = {
    labels,
    datasets: [
      {
        data: labels.map((key) => data[key].Total),
        backgroundColor: config.backgroundColor,
        borderColor: config.borderColor,
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <Doughnut data={result} options={config.options} />
      {loading && <LinearProgress />}
    </>
  );
}

export { GraphicDoughnut };
